//  font renamed as cardiuma-M  - 23-08-24 - Dev Srini
const styles = theme => ({
    dashboardText2: {
        color: 'var(--b, #FFF) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '34px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

    horizantalTablayout: {
        width: '99% ! important',
        height: 'auto',
        flexShrink: 0,
        borderRadius: '10px',
        background: '#131E2E',
        overflowY: 'auto'
    },

    tableHeading1: {
        width: '132px ',
        color: 'var(--b, #747474) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '18px ! important'
    },

    tableHeading2: {
        width: '92px',
        color: 'var(--b, #747474) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '18px ! important'
    },

    tableHeading3: {
        width: '72px',
        color: 'var(--b, #747474) ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '18px ! important'
    },

    rowText: {
        color: 'var(--b, #FFF)  ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px  ! important',
        fontStyle: 'normal',
        fontWeight: '400  ! important',
        lineHeight: '18px  ! important'
    },

    modalheading: {
        color: '#000',
        fontFamily: 'cardiuma-SemiBold ! important',
        fontSize: '24px ! important',
        fontStyle: 'normal',
        fontWeight: '600 ! important',
        lineHeight: '18px ! important',
    },

    //department
    addUserText: {
        color: 'var(--CTA, #F74542) ! important',
        fontFamily: 'cardiuma-Bold ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '700 ! important',
        lineHeight: '20px ! important'

    },

    modalCard2: {
        width: '536px',
        height: '404px',
        flexShrink: 0,
        borderRadius: '14px',
        background: 'var(--b, #FFF)',
    },

    formlabel1: {
        color: '#333333',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '15px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important',
        paddingBottom: '5px ! important'

    },
    errtxt: {
        color: '#F74542 !important', fontFamily: 'cardiuma-regular !important', fontSize: '12px !important',
    },
    horizantaltablayout: {
        // 28-Feb-2024 - Amended width & marginLeft for required page alignment - developer Srini
        width: '105% ! important',
        marginLeft: '-100px',
        flexShrink: 0,
        borderRadius: '10px',
        background: '#131E2E',
        overflowY: 'auto'
    },


    //roles
    inputtext1: {
        color: '#333333 ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '12px ! important',
        fontStyle: 'normal',
        fontWeight: '400 ! important',
        //lineHeight: '20px'
    },

    modalCard1: {
        width: '840px',
        height: '525px', // srini - 20/12/24
        flexShrink: 0,
        borderRadius: '14px',
        background: 'var(--b, #FFF)',
    },
    // added by srini on 16-01-25
    pagination: {
        '& .MuiTablePagination-select': { color: '#fff' }, // Style select dropdown text color
        '& .MuiTablePagination-toolbar': { color: 'white' }, // Style toolbar text color
        '& .MuiTablePagination-caption': { color: 'white' }, // Style caption text color
        '& .MuiTablePagination-actions': { color: 'white' }, // Style pagination actions color,
        '& .MuiSvgIcon-root.MuiTablePagination-selectIcon': {
            color: 'white', // Apply color to the select icon
        },
    }
})

export default styles